import { identity } from "@workspace/mobile";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { getEnvironmentProps, isDmnURL } from "../../utils/environment";
import { apiFetchNotOkHandler, errorHandler } from "../errorHandler";

export const getButtonToken = async (): Promise<Response> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentProps = getEnvironmentProps(token) ?? null;

  try {
    const response = await fetch(
      `${environmentProps?.AUTH_API_BASE_URL}/evo/collins/button/token`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      apiFetchNotOkHandler(response, "Error fetching button token");
      if (!isDmnURL()) {
        const identityEvoResponse = {
          access_token: await identity.getIdToken(),
          expires_in: 3600,
          token_type: "Bearer"
        };

        return new Response(JSON.stringify(identityEvoResponse));
      }
    }

    return response;
  } catch (error) {
    errorHandler(error, "Error fetching button token");

    if (!isDmnURL()) {
      const identityEvoResponse = {
        access_token: await identity.getIdToken(),
        expires_in: 3600,
        token_type: "Bearer"
      };
      return new Response(JSON.stringify(identityEvoResponse));
    } else {
      return new Response("Error fetching button token", { status: 500 });
    }
  }
};
